import React, { Component } from 'react'
import 'worldwindjs'
// import axios from 'axios';
import request from '../../utils/request'
import { osintRequestAddress } from '../config'

export default class PeopleLayer extends Component{
    state = {
        isPersonListGot: false
    }

    componentDidMount(){
        if (this.state.isPersonListGot){
            return
        }  
        const token = localStorage.getItem('token')
        // axios.get(`https://www.osintsee.com/person`, {
        //     headers: {
        //         'Authorization': token,
        //     },
        // }).
        request({
            url: `${osintRequestAddress}/person`,
            headers: {
                'Authorization': token,
            },
            method: 'get',
        }).then(
            response => {
                if (response && response.length>0){
                    response.map(
                        (person) => this.props.addPerson(person)                    
                    )                   
                    this.setState({isPersonListGot:true})
                }
            },
            error => {console.log("error",error)}
        )
    } 
    render(){
        return <div></div>
    }
}
